import {
  useCallback, useState,
} from 'react';

/**
 * Toggle state for content that stays visible on desktop but collapses on mobile (via CSS).
 * Typical pattern: control in the page header row + `MobileCollapsible` around the target block.
 * @param {{ initialOpen?: boolean }} [options]
 * @returns {{
 *   isOpen: boolean,
 *   setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
 *   onToggleClick: () => void,
 * }}
 */
export function useMobileReveal({ initialOpen = false } = {}) {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const onToggleClick = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    setIsOpen,
    onToggleClick,
  };
}
